// Time intervals for different activities
const workoutOptionsEn = {
  musclegain: {
    push: "Push",
    pull: "Pull",
    legs: "Legs",
    arms: "Arms",
    shoulders: "Shoulders",
    core: "Core",
    fullbody: "Full Body",
    calisthenics: "Calisthenics",
  },
  strength: {
    push: "Push",
    pull: "Pull",
    legs: "Legs",
    arms: "Arms",
    shoulders: "Shoulders",
    core: "Core",
    fullbody: "Full Body",
    calisthenics: "Calisthenics",
  },
  weightloss: {
    push: "Push",
    pull: "Pull",
    legs: "Legs",
    arms: "Arms",
    shoulders: "Shoulders",
    core: "Core",
    fullbody: "Full Body",
    calisthenics: "Calisthenics",
    cardio: "Cardio",
  },
  generalhealth: {
    push: "Push",
    pull: "Pull",
    legs: "Legs",
    arms: "Arms",
    shoulders: "Shoulders",
    core: "Core",
    fullbody: "Full Body",
    calisthenics: "Calisthenics",
    stretch: "Stretch",
    cardio: "Cardio",
  },
};

const workoutOptionsFr = {
  musclegain: {
    push: "Pousser",
    pull: "Tirer",
    legs: "Jambes",
    arms: "Bras",
    shoulders: "Épaules",
    core: "Tronc",
    fullbody: "Corps entier",
    calisthenics: "Calisthenics",
  },
  strength: {
    push: "Pousser",
    pull: "Tirer",
    legs: "Jambes",
    arms: "Bras",
    shoulders: "Épaules",
    core: "Tronc",
    fullbody: "Corps entier",
    calisthenics: "Calisthenics",
  },
  weightloss: {
    push: "Pousser",
    pull: "Tirer",
    legs: "Jambes",
    arms: "Bras",
    shoulders: "Épaules",
    core: "Tronc",
    fullbody: "Corps entier",
    calisthenics: "Calisthenics",
    cardio: "Cardio",
  },
  generalhealth: {
    push: "Pousser",
    pull: "Tirer",
    legs: "Jambes",
    arms: "Bras",
    shoulders: "Épaules",
    core: "Tronc",
    fullbody: "Corps entier",
    calisthenics: "Calisthenics",
    stretch: "Étirement",
    cardio: "Cardio",
  },
};

const defaultOption = "musclegain";

// Function to generate time options based on the activity type
export const generateWorkoutOptions = (goal, language) => {
  const workoutKey = goal || defaultOption;
  if (workoutKey && language === "en") {
    return workoutOptionsEn[workoutKey];
  } else if (workoutKey && language === "fr") {
    return workoutOptionsFr[workoutKey];
  } else {
    // Provide a default or return an error
    console.error("Invalid activity specified");
    return workoutOptionsEn[defaultOption];
  }
};
